import PropTypes from 'prop-types'
import { createSelector } from 'reselect'

import sentryError from '../../../utils/analytics/error'
import API from '../../../utils/http/api'

// Action Types ===========================================
export const REQUEST = 'steppingblocks/insToken/REQUEST'
export const SUCCESS = 'steppingblocks/insToken/SUCCESS'
export const FAILURE = 'steppingblocks/insToken/FAILURE'
export const CLEAR = 'steppingblocks/insToken/CLEAR'

// Reducer ================================================
const initialState = {
  error: null,
  insToken: null,
  result: null,
  requestEnded: false,
  requestStarted: false,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        insToken: null,
        result: null,
        requestStarted: true,
        requestEnded: false,
      }
    case SUCCESS:
      return {
        ..._state,
        insToken: payload.insToken,
        result: payload.result,
        requestEnded: true,
      }
    case FAILURE:
      return {
        ..._state,
        error: payload.error,
        requestEnded: true,
      }
    case CLEAR:
      return {
        ..._state,
        insToken: null,
        result: null,
      }
    default:
      return _state
  }
}

// Thunks =================================================
export const performValidateInsToken = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.get(
      `/users/validate-instoken?insToken=${encodeURIComponent(params.insToken)}`,
    )
    dispatch({ type: SUCCESS, payload: { insToken: data.insToken, result: data.result } })
  } catch (error) {
    error.type = 'Important'
    dispatch({ type: FAILURE, payload: { error: error.message } })
    sentryError.report(error, 'insToken')
  }
}

export const clearInsToken = () => async dispatch => dispatch({ type: CLEAR })

// Selectors ==============================================
const insToken = state => state.insToken
const getInsToken = state => state.insToken.insToken

export const getName = createSelector(insToken, _ => _.result && _.result.name)

export const getValidatedInsToken = createSelector([getInsToken], insToken => insToken || null)

export const hasInsTokenResults = createSelector(insToken, _ => (_.result ? true : false))

export const getInsTokenLogo = createSelector(insToken, _ => _.result && _.result.logo)

export const getInsTokenModules = createSelector(insToken, _ => _.result && _.result.modules)

// PropTypes ==============================================
export const propTypes = PropTypes.shape({
  error: PropTypes.any,
  insToken: PropTypes.string,
  requestEnded: PropTypes.bool.isRequired,
  requestStarted: PropTypes.bool.isRequired,
})

// Spec ===================================================
export const testData = {
  error: null,
  insToken: 'ST12345s1',
  requestEnded: false,
  requestStarted: false,
}



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Onboarding/insTokenDuck.js